import { LANDING_PAGE_FORM_INITIAL_VALUES } from '@app/code/src/constants/landing-page'
import {
  LandingPageDestination,
  LandingPageFormValuesType
} from '@dtx-company/inter-app/src/types/flowcode'
import { UseFormReturn, useForm } from 'react-hook-form'
import { useCreateFlowcodeState } from '@app/code/src/hooks/useCreateFlowcodeState'
import React, {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  createContext,
  useMemo,
  useState
} from 'react'

export type CreateFlowcodeFormContextType = UseFormReturn<LandingPageFormValuesType> & {
  isDestinationValidating: boolean
  setIsDestinationValidating: Dispatch<SetStateAction<boolean>>
}

export const CreateFlowcodeFormContext = createContext<CreateFlowcodeFormContextType | undefined>(
  undefined
)

export const CreateFlowcodeFormProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { destination } = useCreateFlowcodeState()
  const destinationId = destination?.id

  const [isDestinationValidating, setIsDestinationValidating] = useState(false)

  const { watch, ...methods } = useForm<
    LandingPageFormValuesType,
    {
      selectedDestination: LandingPageDestination
    }
  >({
    defaultValues: LANDING_PAGE_FORM_INITIAL_VALUES,
    // this is currently unused, but any values passed here will be accessible from the resolver
    context: {
      selectedDestination: destinationId
    },
    reValidateMode: 'onChange',
    mode: 'onBlur'
  })

  const value = useMemo(() => {
    return {
      ...methods,
      watch,
      isDestinationValidating,
      setIsDestinationValidating
    }
  }, [watch, methods, isDestinationValidating, setIsDestinationValidating])

  return (
    <CreateFlowcodeFormContext.Provider value={value}>
      {children}
    </CreateFlowcodeFormContext.Provider>
  )
}
